export const operators = [
    {
        value: 'equal',
        label: ' = ',
        type: 'one',
    },
    {
        value: 'not-equal',
        label: ' != ',
        type: 'one',
    },
    {
        value: 'in',
        label: ' in ',
        type: 'one',
    },
    {
        value: 'greater-than',
        label: ' > ',
        type: 'one',
    },
    {
        value: 'greater-or-equal-than',
        label: ' >= ',
        type: 'one',
    },
    {
        value: 'less-than',
        label: ' < ',
        type: 'one',
    },
    {
        value: 'less-or-equal-than',
        label: ' <= ',
        type: 'one',
    },
    {
        value: 'is-checked',
        label: ' is checked ',
        type: 'bool',
    },
    {
        value: 'is-not-checked',
        label: ' is !checked ',
        type: 'bool',
    },
    {
        value: 'contains',
        label: ' contains ',
        type: 'multi',
    },
    {
        value: 'selected',
        label: ' selezionato ',
        type: 'data',
    },
    {
        value: 'not-selected',
        label: ' non selezionato ',
        type: 'data',
    },
];
export const features = [
    {
        value: 'required',
        label: 'obbligatorio ...',
    },
    {
        value: 'disabled',
        label: 'disabilitato ...',
    },
    {
        value: 'visibility',
        label: 'visibile ...',
    },
    {
        value: 'assign',
        label: 'assegna valore ...',
    },
];
